export function BookmarkFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4 5a3 3 0 013-3h10a3 3 0 013 3v16a.996.996 0 01-1.029 1 .996.996 0 01-.626-.244L12 16.317l-6.345 5.439a.995.995 0 01-1.275.029A.998.998 0 014 21V5z"
      ></path>
    </svg>
  );
}
